export enum CreateStrategyAssetStepEnum {
  'CUSTOM_CATEGORY' = 'CUSTOM_CATEGORY',
  'CUSTOM_ASSET' = 'CUSTOM_ASSET',
  'WALLET_CONNECT' = 'WALLET_CONNECT',
  'WALLET_ASSETS' = 'WALLET_ASSETS',
  'BANK_ASSETS' = 'BANK_ASSETS',
  'BANK_CONNECT' = 'BANK_CONNECT',
  'FINANCIAL' = 'FINANCIAL',
  'NFT' = 'NFT',
  'PROPERTY' = 'PROPERTY',
  'INITIAL' = 'INITIAL',
  'EDIT' = 'EDIT',
}
